import { createFileRoute } from '@tanstack/react-router'

import EditAnggotaPoktanPage from '@/components/pages/backoffice/_klb-petani/_poktan/_$poktanId/_anggota/_$anggotaPoktanId/_edit/containers/EditAnggotaPoktanPage'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/edit'
)({
  component: EditAnggotaPoktanPage
})
